import _slicedToArray from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/layouts/Grid/grid';
import { css } from '@patternfly/react-styles';
import { DeviceSizes } from '../../styles/sizes';
export var GridItem = function GridItem(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$span = _a.span,
      span = _a$span === void 0 ? null : _a$span,
      _a$rowSpan = _a.rowSpan,
      rowSpan = _a$rowSpan === void 0 ? null : _a$rowSpan,
      _a$offset = _a.offset,
      offset = _a$offset === void 0 ? null : _a$offset,
      props = __rest(_a, ["children", "className", "span", "rowSpan", "offset"]);

  var classes = [styles.gridItem, span && styles.modifiers["".concat(span, "Col")], rowSpan && styles.modifiers["".concat(rowSpan, "Row")], offset && styles.modifiers["offset_".concat(offset, "Col")]];
  Object.entries(DeviceSizes).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        propKey = _ref2[0],
        classModifier = _ref2[1];

    var key = propKey;
    var rowSpanKey = "".concat(key, "RowSpan");
    var offsetKey = "".concat(key, "Offset");
    var spanValue = props[key];
    var rowSpanValue = props[rowSpanKey];
    var offsetValue = props[offsetKey];

    if (spanValue) {
      classes.push(styles.modifiers["".concat(spanValue, "ColOn").concat(classModifier)]);
    }

    if (rowSpanValue) {
      classes.push(styles.modifiers["".concat(rowSpanValue, "RowOn").concat(classModifier)]);
    }

    if (offsetValue) {
      classes.push(styles.modifiers["offset_".concat(offsetValue, "ColOn").concat(classModifier)]);
    }

    delete props[key];
    delete props[rowSpanKey];
    delete props[offsetKey];
  });
  return React.createElement("div", Object.assign({
    className: css.apply(void 0, classes.concat([className]))
  }, props), children);
};